module.exports = __webpack_public_path__ + "img/enterprises.2c3fdac6.png";